import { FacebookNotGrantedAccessError } from './../../application/usecases/facebookInteractor';
import { Email } from './../../domain/user';
import { FacebookAccessToken } from './../../domain/facebook';
import { Right, PromiseEither, Left } from './../../utils/either';
import { Option } from '../../utils/option';
import env from '../../utils/env';

export default class FacebookHandler {
  private static singleton: FacebookHandler;

  private constructor() {
    // FBが読まれてないときにsetImmidiateループで読まれるのを待たほうがいいかも？
    FB.init({
      appId: env.facebookAppId.get(),
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v3.2'
    });
  }

  public static get instance(): FacebookHandler {
    if (!this.singleton) {
      this.singleton = new FacebookHandler();
    }
    return this.singleton;
  }

  public async me(): PromiseEither<Error, Option<Email>> {
    return new Promise((resolve) => {
      FB.api('/me', { fields: 'email' }, ({ email }: { email?: string }) => {
        resolve(new Right(Option(email)));
      });
    });
  }

  public async login(): PromiseEither<Error, FacebookAccessToken> {
    return new Promise((resolve) => {
      FB.login(
        ({ status, authResponse }) => {
          if (status === 'connected') {
            resolve(new Right(authResponse.accessToken));
          }
          resolve(new Left(new FacebookNotGrantedAccessError()));
        },
        { scope: 'public_profile,email' }
      );
    });
  }
}
